<!-- 车场通道信息变更上报 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                // "cmd": "reportShift",
                "parkCode": "2KM9J7GC",
                "updateTime": "20170929162050",
                "shiftdataListList": [
                    {
                        "channelId": 2,
                        "channelName": '开发出口',
                        "entranceType": 2,
                        "normalCarPassMode": 2,
                        "noPlatePassMode": 2,
                        "areaId": '2,41',
                        "enable": 1,
                        "blueCarPassMode": 1,
                        "yellowCarPassMode": 1,
                        "newEnergyCarPassMode": 2,
                        "newEnergyTruckPassMode": 2,
                        "dataState": 2,
                    }
                ]
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台主动上报停车场车场通道信息变更上报到第三方接入系统",
                urlPattern:this.commonUrls.third+"reportChannelChanges",
                precondition: "VEMS 2.10.5及以上版本",
                fitSystem: "VEMS停车场",
                pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
                frequency:"实时触发",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'updateTime', info2: '是', info3: 'String', info4: '更新时间(yyyMMddHHmmss)' },
                        { info1: 'dataList', info2: '是', info3: 'JSONArray', info4: '通道变更列表' }
                        ]
                },{
                    titleName: 'dataList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'channelId', info2: '是', info3: 'String', info4: '通道编号' },
                        { info1: 'channelName', info2: '是', info3: 'String', info4: '通道名称' },
                        { info1: 'areaId', info2: '是', info3: 'String', info4: '要结账的区域，使用逗号分隔' },
                        { info1: 'enable', info2: '是', info3: 'Integer', info4: '通道状态 0未启用，1启用， 2禁用' },
                        { info1: 'entranceType', info2: '是', info3: 'Integer', info4: '通道类型 0：未确认，1：进口，2：出口' },
                        { info1: 'normalCarPassMode', info2: '否', info3: 'Integer', info4: '临时车放行模式 0未设定，1手动验证放行，2自动验证放行，3自定义' },
                        { info1: 'noPlatePassMode', info2: '否', info3: 'Integer', info4: '无牌车通行模式 0未设定，1手动验证放行，2自动验证放行' },
                        { info1: 'blueCarPassMode', info2: '否', info3: 'Integer', info4: '蓝牌车放行模式 1手动验证放行，2自动验证放行,当normalCarPassMode=3时此项必填' },
                        { info1: 'yellowCarPassMode', info2: '否', info3: 'Integer', info4: '黄牌车放行模式 1手动验证放行，2自动验证放行,当normalCarPassMode=3时此项必填' },
                        { info1: 'newEnergyCarPassMode', info2: '否', info3: 'Integer', info4: '新能源小车放行模式 1手动验证放行，2自动验证放行,当normalCarPassMode=3时此项必填' },
                        { info1: 'newEnergyTruckPassMode', info2: '否', info3: 'Integer', info4: '新能源大车放行模式 1手动验证放行，2自动验证放行,当normalCarPassMode=3时此项必填' },
                        { info1: 'dataState', info2: '是', info3: 'Integer', info4: '数据状态 0:新增 1:更新 2:删除' },
                        ]

                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: []
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [
                        ]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/upward/reportChannelChanges.vue